//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


export default {
  data() {
      return {
        show: false,
      };
  },
  
  props: {

  },
  
  computed: {

  },
  
  watch: {

  },
  
  methods: {

  },
  
  components: {

  },
  
  created() {
    
  },
  mounted() {

  },
};




// WEBPACK FOOTER //
// ./scripts/vue/SubscribeBanner.vue